import { z } from 'zod';

export const AppLanguageSchema = z.enum([ 'de', 'en' ]);
export type AppLanguage = z.infer<typeof AppLanguageSchema>;
